import React from 'react';
import { string } from 'prop-types';

const SectionTitle = ({ sectionTitle }) => <h2>{sectionTitle}</h2>;

SectionTitle.propTypes = {
  sectionTitle: string.isRequired,
};

export default SectionTitle;



// WEBPACK FOOTER //
// ./src/components/common/SectionTitle.js